import { Router } from 'express';
import { authMiddleware, AuthRequest } from '../../middleware/auth.middleware';
import * as service from './notifications.service';
import { Response, NextFunction } from 'express';

const router = Router();
router.use(authMiddleware);

router.get('/', async (req: AuthRequest, res: Response, next: NextFunction) => {
  try {
    const data = await service.getNotifications(req.user!.sub, Number(req.query.page) || 1);
    res.json({ success: true, data });
  } catch (err) { next(err); }
});

router.post('/read-all', async (req: AuthRequest, res: Response, next: NextFunction) => {
  try {
    await service.markAllRead(req.user!.sub);
    res.json({ success: true });
  } catch (err) { next(err); }
});

router.patch('/:id/read', async (req: AuthRequest, res: Response, next: NextFunction) => {
  try {
    await service.markRead(req.params.id, req.user!.sub);
    res.json({ success: true });
  } catch (err) { next(err); }
});

export default router;
